import { FormProvider } from 'react-hook-form';
import strings from "../../../../localization";
import Button from '@mui/material/Button';
import TextFieldControl from "../../../Controls/Inputs/TextFieldControl";
import AutoCompleteControl from "../../../Controls/Inputs/AutoCompleteControl";

const WorkspaceForm = (props) => {
    const {formRules, form, values, data, onSubmit, onCancel, errors, setValue, pipelines, control, onChangePipelineFilter} = props;

    return (
        <FormProvider {...form}>
            <form className = 'form' action = '#'>
                <TextFieldControl
                    name = 'name'
                    control = {data}
                    rules = {formRules['name']}
                    helperText={errors.name && strings.forms.common.thisFieldIsRequired}
                    error = {Boolean(errors.name)}
                    label = {strings.forms.workspaces.name}
                />
                <TextFieldControl
                    name = 'description'
                    control = {data}
                    label = {strings.forms.workspaces.description}
                    rules = {formRules['description']}
                    helperText={errors.description && strings.forms.common.thisFieldIsRequired}
                    error = {Boolean(errors.description)}
                />
                <AutoCompleteControl
                    name='pipeline'
                    nameKey={'name'}
                    valueKey={'id'}
                    control = {control}
                    value={values['pipeline']}
                    setValue={setValue}
                    rules = {formRules['pipeline']}
                    error = {Boolean(errors.pipeline)}
                    helperText={errors.pipeline && strings.forms.common.thisFieldIsRequired}
                    label = {strings.forms.workspaces.pipeline}
                    options = {pipelines}
                    onChange={onChangePipelineFilter}
                    onOpen={() =>onChangePipelineFilter('')}
                />
                <div className='submit-container'>
                    <Button variant="contained" color="primary" onClick={onSubmit}>
                        {strings.forms.common.save}
                    </Button>
                    <Button variant="contained" color="secondary" onClick={onCancel}>
                        {strings.forms.common.cancel}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};

export default WorkspaceForm;
